import { Slide, ToastOptions, toast } from 'react-toastify';

const getToastOptions = (autoClose?: number | boolean) => ({
  autoClose: autoClose,
  position: "top-right",
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: false,
  theme: "colored",
  transition: Slide
} as ToastOptions<{}>)

export const notifySuccess = (message: string = 'Request completed', autoClose?: number) => {
  toast.success(message, getToastOptions(autoClose ?? 3000))
}

export const notifyError = (message: string) => {
  toast.error(message, {
    ...getToastOptions(false),
    className: "notify-error"
  })
}

export const notifyWarning = (message: string, autoClose?: number) => {
  toast.warn(message, getToastOptions(autoClose))
}
